import Head from "next/head";

import UploadBoard from "../components/UploadBoard";
import { FlashPCBPage } from "../models/page";
import { BoardHeader } from "../components/Header/BoardHeader";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { CADSources } from "../reducers/uploadedBoard";
import { ParsedUrlQuery } from "node:querystring";

const UploadBoardPage: FlashPCBPage<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({ initialCADSource }) => {
  return (
    <>
      <Head>
        <title>Upload your board</title>
        <meta name="description" content="Upload to get a quote" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <UploadBoard initialCADSource={initialCADSource} />
    </>
  );
};

UploadBoardPage.Header = BoardHeader;

function getInitialCADSourceFromQuery(query: ParsedUrlQuery) {
  const cadInQuery = query.cad;
  if (typeof cadInQuery === "string") {
    const matchingCADSource = Object.values(CADSources).find(
      (cadSource) => cadSource.toLowerCase() == cadInQuery.toLowerCase(),
    );
    if (matchingCADSource !== undefined) {
      return matchingCADSource;
    }
  }
  return CADSources.GERBER;
}

export const getServerSideProps = (async ({ query }) => {
  return { props: { initialCADSource: getInitialCADSourceFromQuery(query) } };
}) satisfies GetServerSideProps<{ initialCADSource: CADSources }>;

export default UploadBoardPage;
